export default "__VITE_ASSET__B4b6nhyG__"